import LegalLayout from "@/components/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions Légales" updated="1er février 2026">
      <div data-testid="legal-notice-page">
        <h2>Éditeur</h2>
        <p>
          <strong>Fabien Deris EI</strong> (Entreprise Individuelle)<br />
          Éditeur et gestionnaire du site <a href="https://mapetiteyole.com">mapetiteyole.com</a><br />
          Contact : <a href="mailto:contact@mapetiteyole.com">contact@mapetiteyole.com</a>
        </p>

        <h2>Directeur de la publication</h2>
        <p>Fabien Deris.</p>

        <h2>Hébergement</h2>
        <p>
          Le site est hébergé par <strong>Emergent Labs</strong> (infrastructure cloud gérée).
          Les données sont stockées sur des serveurs sécurisés au sein de l'Union européenne.
        </p>

        <h2>Nature du Service</h2>
        <p>
          Ma Petite Yole est une application de <strong>pronostics amicaux sans enjeu monétaire</strong>,
          adossée au Tour des Yoles Rondes de Martinique. Les points affichés sont <strong>strictement
          virtuels</strong> et n'ont aucune valeur marchande. Le Service ne constitue en aucun cas
          un jeu d'argent au sens de la loi n° 2010-476 du 12 mai 2010 et n'est donc pas soumis
          à l'agrément de l'Autorité Nationale des Jeux (ANJ).
        </p>

        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments de ce site (logo, illustrations, textes, code, charte graphique)
          est protégé par le droit d'auteur et le droit des marques. Toute reproduction, même
          partielle, est interdite sans autorisation préalable.
        </p>
        <p>
          Les photos des yoles restent la propriété de leurs auteurs respectifs. Les données de
          suivi en direct sont fournies par Georacing et affichées à titre informatif.
        </p>

        <h2>Liens et intégrations externes</h2>
        <p>
          Ma Petite Yole peut intégrer des contenus tiers (Georacing pour la carte en direct,
          Google pour l'authentification). L'éditeur n'exerce aucun contrôle sur ces services
          externes et ne pourrait être tenu responsable de leur contenu.
        </p>

        <h2>Signaler un contenu</h2>
        <p>
          Pour signaler un contenu illicite, un manquement aux CGU ou un problème technique :{" "}
          <a href="mailto:contact@mapetiteyole.com">contact@mapetiteyole.com</a>.
        </p>

        <h2>Crédits</h2>
        <p>
          Conception et développement : Fabien Deris avec l'assistance d'Emergent.
          Suivi en direct des courses : <a href="https://www.georacing.com" target="_blank" rel="noopener noreferrer">Georacing</a>.
        </p>
      </div>
    </LegalLayout>
  );
}
